import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

const growUp = keyframes`
  from{
    margin-bottom: 0;
    transform: scale(0);
  }

  to {
    transform: scale(1);
    margin-bottom: ${theme.spacing['2xl']};
  }
`

export const ErrorWrapper = styled.div`
  animation: ${growUp} 0.3s ease-out;
  margin-bottom: ${theme.spacing.lg};

  &.removeBigSpace {
    margin-top: -${theme.spacing.xm};
    margin-bottom: ${theme.spacing.sm};
  }
`

export const FieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;
  margin-bottom: ${theme.spacing.md};

  .title {
    text-align: center;
    color: ${theme.colors.neutral.black};
    margin-bottom: ${theme.spacing.xm};
  }

  .description {
    text-align: center;
    margin-bottom: ${theme.spacing.lg};
    padding: 0 ${theme.spacing.md};
  }
`
export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
  margin-top: ${theme.spacing.lg};
`
export const LinkGoBackContainer = styled.div`
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
`

export const ResendCode = styled.span`
  color: ${theme.colors.primary.main};
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes.xs};
  text-decoration: underline;
  margin-top: ${theme.spacing.lg};
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
`
